import { render, staticRenderFns } from "./OrganismCardForm.vue?vue&type=template&id=2416e560"
import script from "./OrganismCardForm.vue?vue&type=script&lang=js"
export * from "./OrganismCardForm.vue?vue&type=script&lang=js"
import style0 from "./OrganismCardForm.vue?vue&type=style&index=0&id=2416e560&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports